import { connect, useDispatch } from "react-redux";
import AcademicProfile from "./components/academicProfile";
import { IStudentAcademicProfile } from "../../../models/dashboard/studentDashboard";
import { useEffect } from "react";
import StudentCourseDetails from "../dashboard/components/studentCourseDetails";
import EarlyAlerts from "./components/earlyAlerts";
import DegreeProgress from "./components/degreeProgress";
import StudentHelp from "./components/studentHelp";
import { getPageBlockData } from "../../../common-functions/commonFunctions";
import { pageBlockId } from "../../../constants/pageBlocks";
import { setSnapShots } from "../../../store/slices/master/snapShotSlice";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";

const StudentAcademicProfile = (props: IStudentAcademicProfile) => {
  const { getSnapShots, snapShots } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSnapShots([]));
    };
  }, []);

  return (
    <>
      <div className="row studpro-mobile">
        <div className="col-lg-8">
          <div className="card-wrap">
            <div className="academic-profile">
              <>
                <AcademicProfile />
              </>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="row h-100">
            <div className="col-lg-12 mb-3">
              <StudentHelp />
            </div>
            <div className="col-lg-12 mb-3">
                <DegreeProgress/>
            </div>
            <div className="col-lg-12 mb-3">
                <EarlyAlerts/>
            </div>
            <div className="col-lg-12">
              <StudentCourseDetails />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="composewrap"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="composewrapLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <h2>Compose</h2>
              <p>
                Select the Department from dropdown. Summarize your query
                briefly and send it to the chosen recipient. You can expect a
                reply within 24 hours.
              </p>
              <div className="emailform mt-3">
                <div className="label-to">
                  <label htmlFor="">From</label>
                  <div className="stude-details">
                    <div className="img">
                      <img src="/assets/images/profile06.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h6>Sam Kann</h6>
                      <p>
                        Departement of Science | <span>Imperial College</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="multiselect-plugin label-to">
                  <label htmlFor="" style={{ height: "44px" }}>
                    To
                  </label>
                  <div id="htmlselect"></div>
                </div>
                <div className="formgroup">
                  <label htmlFor="">Subject</label>
                  <input type="text" />
                </div>
                <div className="formgroup">
                  <label htmlFor="">Message</label>
                  <textarea name="" id=""></textarea>
                </div>
              </div>
            </div>
            <div className="modal-footer mb-4">
              <button type="button" className="btn btn-primary">
                Send
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
};

function mapStateToProps(state: any) {
  return {
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentAcademicProfile);
